module.exports = __webpack_public_path__ + "static/media/FigmaDashBoard.fbb53fc1.png";